/* KNOCDIC site-wide effects 2026-10-17. Plain JS + IntersectionObserver, no libraries. */
(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  function q(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s));}
  function init(){
    var main = document.getElementById('MainContent') || document.querySelector('main');
    if(!main) return;
    // 1. Wavy dividers between major sections (not before the first, not inside header/footer)
    var secs = q(':scope > .shopify-section', main);
    var D='M0 11 C 90 3, 170 19, 260 11 S 430 2, 520 12 S 690 20, 790 10 S 960 3, 1050 12 S 1160 17, 1200 10';
    function solid(c){ return c && c!=='transparent' && !/rgba\(/.test(c); } // translucent overlays don't count
    function edgeBg(el, bottom){ // deepest full-width background at the section's top/bottom edge
      var found=null, cur=el, W=el.getBoundingClientRect().width||1;
      for(var d=0; cur && d<8; d++){
        var cs=getComputedStyle(cur); if(solid(cs.backgroundColor)) found=cs.backgroundColor;
        var kids=Array.prototype.filter.call(cur.children,function(k){var r=k.getBoundingClientRect();return r.height>0 && r.width>=Math.min(W,window.innerWidth)-4 && getComputedStyle(k).position!=='absolute';});
        cur = kids.length ? kids[bottom?kids.length-1:0] : null;
      }
      if(found) return found;
      for(var a=el.parentElement;a;a=a.parentElement){ var c=getComputedStyle(a).backgroundColor; if(solid(c)) return c; }
      return 'rgb(255, 255, 255)';
    }
    function edgeMedia(sec, bottom){ // full-width image/video/bg-image block flush with the section edge; product cutouts excluded
      var R=sec.getBoundingClientRect(), best=null;
      q('img,video,picture,[style*="background-image"]',sec).forEach(function(m){
        if(m.closest('.product-card,.rhb,[class*="product__media"],[class*="product-media"],.tf-blob-host')) return;
        var el=(m.tagName==='IMG'&&m.parentElement.tagName==='PICTURE')?m.parentElement:m, r=el.getBoundingClientRect();
        if(r.width<R.width*0.9||r.height<120) return;
        var gap=bottom ? R.bottom-r.bottom : r.top-R.top;
        if(gap<=80 && gap>-2) best=el;
        else if(gap<=0) best=sec; // media bleeds past the edge (parallax/cover): cut the section itself

      });
      return best;
    }
    secs.forEach(function(s,i){
      if(i===0 || s.offsetHeight < 200) return;
      var prev=s.previousElementSibling; while(prev && !prev.classList.contains('shopify-section')) prev=prev.previousElementSibling;
      var top=prev?edgeBg(prev,true):edgeBg(main,false), bot=edgeBg(s,false), svg;
      // media touching the boundary: cut the image edge into the same wave instead of a straight edge
      var mPrev=prev&&edgeMedia(prev,true), mNext=edgeMedia(s,false);
      if(mPrev||mNext){
        if(mPrev){ mPrev.classList.add('tf-wmask-b'); prev.style.backgroundColor=bot; }
        if(mNext){ mNext.classList.add('tf-wmask-t'); s.style.backgroundColor=mPrev?'':top; }
        return;
      }
      if(top===bot){
        svg='<svg class="tf-wave" viewBox="0 0 1200 22" preserveAspectRatio="none" aria-hidden="true"><path d="'+D+'"/></svg>';
      } else {
        svg='<svg class="tf-wave tf-wave--fill" viewBox="0 0 1200 22" preserveAspectRatio="none" aria-hidden="true" style="background:'+top+';color:'+bot+'"><path d="'+D+' L1200 23 L0 23 Z"/></svg>';
      }
      s.insertAdjacentHTML('beforebegin', svg);
    });
    // 1b. Any remaining full-width image edge that meets another section gets the same wave cut
    secs.forEach(function(s,i){
      if(s.offsetHeight<120) return;
      var nx=secs[i+1], pv=secs[i-1];
      var mb=nx&&edgeMedia(s,true), mt=pv&&i>0&&edgeMedia(s,false);
      if(mb&&!mb.classList.contains('tf-wmask-b')){ mb.classList.add('tf-wmask-b'); s.style.backgroundColor=edgeBg(nx,false); }
      if(mt&&!mt.classList.contains('tf-wmask-t')){ mt.classList.add('tf-wmask-t'); if(!mb) s.style.backgroundColor=edgeBg(pv,true); }
    });
    // 2. Hover image swap: second product image from the card's template
    q('.product-card').forEach(function(card){
      if(card.querySelector('.product-card__carousel, .product-card__image--secondary, [class*="secondary-image"]')) return; // theme has its own hover media
      var link = card.querySelector('.product-card__media a.media'); if(!link || link.querySelector('.tf-swap-img')) return;
      var t = link.querySelector('template'); if(!t) return;
      var imgs = t.content ? t.content.querySelectorAll('img') : []; if(imgs.length < 2) return;
      var img = document.createElement('img');
      img.className='tf-swap-img'; img.alt=''; img.loading='lazy'; img.src=imgs[1].getAttribute('src');
      link.classList.add('tf-swap'); link.appendChild(img);
    });
    // 3. Ripple blob behind hero / feature images (first two large media blocks)
    q('main .shopify-section').slice(0,3).forEach(function(s){
      var m = s.querySelector('.image-with-text__media, [class*="hero"] picture, [class*="media-with-text"] .media');
      if(m && !s.querySelector('.rhb') && !m.querySelector('.tf-blob')){ m.parentElement.classList.add('tf-blob-host'); var b=document.createElement('span'); b.className='tf-blob'; b.setAttribute('aria-hidden','true'); m.parentElement.insertBefore(b,m); }
    });
    if(reduce || !('IntersectionObserver' in window)) return;
    // 4. Scroll reveal, staggered
    root.classList.add('tf-js');
    var targets = q('.self-button, main h1, main h2, main h3, main .product-card, main .multicolumn-card, main .rte > p');
    var vh = window.innerHeight;
    targets.forEach(function(el){
      var r = el.getBoundingClientRect();
      if(r.top < vh) return; // already on screen: never hide it
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--tf-d', Math.min(sib,5)*80 + 'ms');
      el.classList.add('tf-reveal');
    });
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('tf-in'); io.unobserve(e.target);} }); }, {rootMargin:'0px 0px -8% 0px'});
    q('.tf-reveal').forEach(function(el){ io.observe(el); });
    // safety: headings visible after 2.5s whatever happens
    setTimeout(function(){ q('h1.tf-reveal,h2.tf-reveal,h3.tf-reveal').forEach(function(h){ var r=h.getBoundingClientRect(); if(r.top<window.innerHeight) h.classList.add('tf-in'); }); }, 2500);
    // 5. Gentle parallax, desktop only, on blob hosts' images
    if(window.matchMedia('(min-width: 1000px) and (hover: hover)').matches){
      var px = q('.tf-blob-host img').slice(0,4), tick=false;
      window.addEventListener('scroll', function(){ if(tick) return; tick=true; requestAnimationFrame(function(){
        px.forEach(function(im){ var r=im.getBoundingClientRect(); var c=(r.top+r.height/2-window.innerHeight/2)/window.innerHeight; im.style.transform='translateY('+(c*-18).toFixed(1)+'px)'; });
        tick=false; }); }, {passive:true});
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
